import { useSelector } from "react-redux";
import * as actions from "./actionTypes";

export const handleTicketArea = (isOpen = true) => ({
  type: actions.HANDLE_MANAGER_TICKET_AREA,
  payload: {
    isOpen,
  },
});

export const getTicketList = () => ({
  type: actions.GET_MANAGER_TICKET_LIST,
});

export const getTicketListSuccess = (data = [], total = 0) => ({
  type: actions.GET_MANAGER_TICKET_LIST_SUCCESS,
  payload: {
    data,
    total,
  },
});

export const getTicketListError = (error = null) => ({
  type: actions.GET_MANAGER_TICKET_LIST_ERROR,
  payload: {
    error,
  },
});

export const setTicketFilter = (filter = {}) => ({
  type: actions.SET_MANAGER_TICKET_FILTER,
  payload: {
    filter,
  },
});

export const resetFilter = () => ({
  type: actions.RESET_MANAGER_TICKET_FILTER,
});

export const nextTicketPage = () => ({
  type: actions.NEXT_MANAGER_TICKET_PAGE,
});

export const prevTicketPage = () => ({
  type: actions.PREV_MANAGER_TICKET_PAGE,
});

export const setTicketPage = (page = 1) => ({
  type: actions.SET_MANAGER_TICKET_PAGE,
  payload: {
    page,
  },
});

export const handleFilterArea = (isOpen = true) => ({
  type: actions.HANDLE_FILTER_AREA,
  payload: {
    isOpen,
  },
});

export const getTicketForms = () => ({
  type: actions.GET_MANAGER_TICKET_FORMS,
});

export const getTicketFormsSuccess = (data = {}) => {
  const skills = data.skills?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const agents = data.agents?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const status = data.status?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  return {
    type: actions.GET_MANAGER_TICKET_FORMS_SUCCESS,
    payload: {
      status,
      skills,
      agents,
    },
  };
};

export const getTicketFormsError = (error = null) => ({
  type: actions.GET_MANAGER_TICKET_FORMS_ERROR,
  payload: {
    error,
  },
});

export const setTicketSort = (sort = {}) => ({
  type: actions.SET_MANAGER_TICKET_SORT,
  payload: {
    sort,
  },
});

export const resetTicketSort = () => ({
  type: actions.RESET_MANAGER_TICKET_SORT,
});
